<template>
  <div v-if="networkResponse && networkResponse.status !== STATUSES.SUCCESS && networkResponse.status !== STATUSES.TEAPOT"
       class="app-alert-error app-system-alert" id="appAlert"
       role="alert" ref="appAlert">
    <img src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <div ref="alertMessageRef" tabindex="-1" v-html="message" class="bannerAlert"> 
    </div>
    <button class="btn-close" type="button" @click="closeBanner()" @keydown.enter="closeBanner()">X</button>
  </div>
</template>


<script setup>
import { ref, computed, watch, onUpdated, nextTick } from 'vue';
import { useStore } from 'vuex';

// Vuex store
const store = useStore();

// Reactive State
const message = ref('');
const errors = ref([
  { code: 400, description: 'Please provide all the required information.' },
  { code: 500, description: 'We are experiencing technical difficulties. Please try your request again.' },
]);

// Computed Properties
const networkResponse = computed(() => store.state.networkResponse);
const STATUSES = computed(() => store.state.STATUSES);

// Template Refs
const alertMessageRef = ref(null);

// Methods 
const setMessage = () => {
  if (networkResponse.value && networkResponse.value.status !== 401) {
    const found = errors.value.find(msg => msg.code === networkResponse.value.status);
    message.value = found ? found.description : `${networkResponse.value.message}`;
  } else if (networkResponse.value && networkResponse.value.status === 401) {
    message.value = networkResponse.value.message || `Unknown error ${networkResponse.value.status}`;
  } else {
    message.value = `Unknown error ${networkResponse.value ? networkResponse.value.status : ''}`;
  }
};

setMessage(); 

watch(networkResponse, () => {
  setMessage();
});

onUpdated(() => {
  nextTick(() => {
    if (alertMessageRef.value) {
      alertMessageRef.value.focus();
    }
  });
});
const closeBanner = () => {
  store.state.networkResponse.status = STATUSES.value.TEAPOT;
  message.value = '';
};
</script>


<style lang="scss" scoped>
@import "~@ridmv/web-themes/styles/system-alert";
</style>
<style scoped>
#appAlert >>> a::after {
  content: url(../../public/static/external-link-alt-solid.svg);
  display: inline-block;
  margin: 0 0.35em;
  vertical-align: middle;
  width: 0.9rem;
}  
#appAlert >>> div {
  font-size: 1rem;
  line-height: 1.5em;
  padding-top: .5em;
  padding-bottom: .5em;
} 

.app-system-alert{
  position: relative;
  .btn-close {
    position: absolute;
    right: 0;
    top: 0;
    min-width: 40px;
    max-width: 40px;
    border: 0px;
    background-color: transparent;
    color: black;
  }
} 
.bannerAlert {
  padding: 0.5em;
}
</style>